webpackJsonp([9],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(10);

var _Booking = __webpack_require__(11);

var _Cf = __webpack_require__(12);

var _Components = __webpack_require__(13);

var components = _interopRequireWildcard(_Components);

__webpack_require__(23);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.mtwp = {
    data: {
        isIE11: !!window.navigator.userAgent.match(/Trident\/7\./)
    },
    modules: {
        components: components
    }

    // ie11 body class
};if (window.mtwp.data.isIE11) {
    document.body.classList.add('ie11');
}

// init components
_lodash2.default.each(mtwp.modules, function (module) {
    if (_lodash2.default.isFunction(module.initialize)) {
        module.initialize(mtwp);
    }
});

// ready components
Promise.resolve().then(function () {
    return new Promise(function (resolve) {
        if (document.readyState === 'loading') {
            document.addEventListener('readystatechange', function () {
                return resolve();
            });
            return;
        } else {
            resolve();
        }
    });
}).then(function () {
    (0, _Booking.bookingFields)();
    (0, _Cf.formHide)();
    _lodash2.default.each(mtwp.modules, function (module) {
        if (_lodash2.default.isFunction(module.ready)) {
            module.ready(mtwp);
        }
    });
});

// cookie
window.addEventListener("load", function () {
    window.cookieconsent.initialise({
        "palette": {
            "popup": {
                "background": "#244081"
            },
            "button": {
                "background": "#f9b113",
                "text": "#ffffff"
            }
        },
        "showLink": false,
        "theme": "classic",
        "content": {
            "message": "Questo sito internet utilizza i cookie per assicurarti la migliore esperienza di navigazione.",
            "dismiss": "Accetto"
        }
    });
});

// cookie mini framework
window.docCookies = {
    getItem: function getItem(sKey) {
        if (!sKey) {
            return null;
        }
        return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
    },
    setItem: function setItem(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
        if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
            return false;
        }
        var sExpires = "";
        if (vEnd) {
            switch (vEnd.constructor) {
                case Number:
                    sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
                    /*
                    Note: Despite officially defined in RFC 6265, the use of `max-age` is not compatible with any
                    version of Internet Explorer, Edge and some mobile browsers. Therefore passing a number to
                    the end parameter might not work as expected. A possible solution might be to convert the the
                    relative time to an absolute time. For instance, replacing the previous line with:
                    */
                    /*
                    sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; expires=" + (new Date(vEnd * 1e3 + Date.now())).toUTCString();
                    */
                    break;
                case String:
                    sExpires = "; expires=" + vEnd;
                    break;
                case Date:
                    sExpires = "; expires=" + vEnd.toUTCString();
                    break;
            }
        }
        document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
        return true;
    },
    removeItem: function removeItem(sKey, sPath, sDomain) {
        if (!this.hasItem(sKey)) {
            return false;
        }
        document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
        return true;
    },
    hasItem: function hasItem(sKey) {
        if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
            return false;
        }
        return new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
    },
    keys: function keys() {
        var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
        for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
            aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
        }
        return aKeys;
    }
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__.p = window.__themeUrl + "/dist/";

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bookingFields = bookingFields;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bookingFields() {
    var form = document.querySelector('.bookly-form');

    if (form) {
        var category = document.querySelectorAll('.bookly-js-select-category');
        var service = document.querySelectorAll('.bookly-js-select-service');

        if (!(category.length && service.length)) {
            setTimeout(function () {
                return bookingFields();
            }, 500);
            return;
        } else {
            _lodash2.default.each(service, function (el) {
                el.setAttribute('disabled', true);
            });
            _lodash2.default.each(category, function (el) {
                el.addEventListener('change', function (e) {
                    if (e.target.value) {
                        _lodash2.default.each(service, function (el) {
                            el.removeAttribute('disabled');
                        });
                    } else {
                        _lodash2.default.each(service, function (el) {
                            el.setAttribute('disabled', true);
                        });
                    }
                });
            });
        }
    }
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formHide = formHide;
function formHide() {
    var wpcf7El = document.querySelector('.wpcf7');
    var thankYouEl = document.querySelector('.form-thank-you');

    if (wpcf7El && thankYouEl) {
        wpcf7El.addEventListener('wpcf7submit', function (e) {
            if (e.detail.status === 'mail_sent') {
                wpcf7El.parentNode.removeChild(wpcf7El);
                thankYouEl.classList.remove('hide');
            }
        }, false);
    }
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.config = exports.instances = undefined;
exports.initialize = initialize;
exports.ready = ready;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _index = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var content = null;

var instances = exports.instances = [];

var config = exports.config = {
    contentSelector: '.content',
    componentNameAttribute: 'data-component',
    componentClass: 'js-component'
};

function initialize(mtwp) {
    _lodash2.default.defer(function () {
        if (mtwp.modules.pageLoader) {
            // destroy and remove components before content replacement
            mtwp.modules.pageLoader.config.hooks.beforeContentReplace.push(function () {
                return onBeforeContentReplace();
            });
            // parse components after page loader content replacement
            mtwp.modules.pageLoader.config.hooks.afterContentReplace.push(function () {
                return parse();
            });
        }
    });
}

function ready(mtwp) {
    content = document.querySelector(config.contentSelector);
    parse();
}

function onBeforeContentReplace() {
    // destroy and remove content components
    _lodash2.default.each(_lodash2.default.filter(instances, function (component) {
        return component.scope === 'content';
    }), function (component) {
        component.$destroy();
        exports.instances = instances = _lodash2.default.without(instances, component);
    });
}

function parse() {
    var componentsEls = document.querySelectorAll('.' + config.componentClass);
    _lodash2.default.each(componentsEls, function (el) {
        var componentName = _lodash2.default.upperFirst(_lodash2.default.camelCase(el.getAttribute(config.componentNameAttribute)));
        (0, _index.importComponent)(componentName).then(function (component) {
            // test if component is global or not
            var scope = 'global';
            var parent = el;
            var componentObject = _lodash2.default.cloneDeep(component.default);

            while (parent && parent.parentNode) {
                if (parent === content) {
                    scope = 'content';
                    parent = null;
                } else {
                    parent = parent.parentNode;
                }
            }

            // extend data object
            if (_lodash2.default.isPlainObject(componentObject.data)) {
                componentObject.data = _lodash2.default.assign(componentObject.data, { scope: scope });
            } else {
                componentObject.data = { scope: scope };
            }

            // set innerHTML as Vue template
            componentObject.template = el.innerHTML.trim();

            // create component and then mount the element
            var componentInstance = new _vue2.default(componentObject);
            componentInstance.$mount(el);

            // remove component attribute and remove the hidden class from the component element
            componentInstance.$el.removeAttribute(config.componentNameAttribute);

            // add the instance to the set
            instances.push(componentInstance);
        }).catch(function (str) {
            return console.error(str);
        });
    });
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.importComponent = importComponent;

__webpack_require__(15);

__webpack_require__(16);

__webpack_require__(17);

__webpack_require__(18);

__webpack_require__(19);

__webpack_require__(20);

__webpack_require__(21);

__webpack_require__(22);

function importComponent(name) {
    if (name === 'Slider') {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 24));
    }

    if (name === 'Tabs') {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 25));
    }

    if (name === 'Map') {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 26));
    }

    if (name === 'ProductsGrid') {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 27));
    }

    if (name === 'Timeline') {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 28));
    }

    if (name === 'ContactsBoxes') {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 29));
    }

    if (name === 'Header') {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 30));
    }

    if (name === 'Overlay') {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 31));
    }

    if (name === 'Faq') {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 32));
    }
}

// only scss

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[9]);


// WEBPACK FOOTER //
// app.js